var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3375 17.2778C27.3375 16.3995 27.3375 15.9603 27.2409 15.6C26.9789 14.6223 26.2152 13.8585 25.2374 13.5965C24.8771 13.5 24.438 13.5 23.5597 13.5C22.6814 13.5 22.2422 13.5 21.8819 13.5965C20.9042 13.8585 20.1404 14.6223 19.8784 15.6C19.7819 15.9603 19.7819 16.3995 19.7819 17.2778M17.1375 30.5H29.9819C31.0398 30.5 31.5687 30.5 31.9728 30.2941C32.3282 30.113 32.6172 29.8241 32.7982 29.4686C33.0041 29.0646 33.0041 28.5357 33.0041 27.4778V20.3C33.0041 19.2421 33.0041 18.7132 32.7982 18.3091C32.6172 17.9537 32.3282 17.6647 31.9728 17.4837C31.5687 17.2778 31.0398 17.2778 29.9819 17.2778H17.1375C16.0796 17.2778 15.5506 17.2778 15.1466 17.4837C14.7912 17.6647 14.5022 17.9537 14.3211 18.3091C14.1152 18.7132 14.1152 19.2421 14.1152 20.3V27.4778C14.1152 28.5357 14.1152 29.0646 14.3211 29.4686C14.5022 29.8241 14.7912 30.113 15.1466 30.2941C15.5506 30.5 16.0796 30.5 17.1375 30.5Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.d8485d93ee626bc4af01c5ebad434487.svg";
export { ForwardRef as ReactComponent };